export default __webpack_public_path__ + "static/media/colorpalette.df99615a.png";